import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getcomplainHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "complain", ...action.payload }),
		);
		yield put({
			type: types.GET_COMPLAIN_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_COMPLAIN_ERROR,
			payload,
		});
	}
}

export function* getcomplainWatcherSaga() {
	yield takeLatest(types.GET_COMPLAIN_START, getcomplainHandlerSaga);
}

//create

//delete

function* deletecomplainHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("complain", action.payload),
		);
		yield put({
			type: types.DELETE_COMPLAIN_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_COMPLAIN_ERROR,
			payload,
		});
	}
}

export function* deletecomplainWatcherSaga() {
	yield takeLatest(types.DELETE_COMPLAIN_START, deletecomplainHandlerSaga);
}

//update
